export const ACTIONS = {
  FETCH_CYCLES_START: "FETCH_CYCLES_START",
  FETCH_CYCLES_SUCCESS: "FETCH_CYCLES_SUCCESS",

  FETCH_EXECUTIONS_START: "FETCH_EXECUTIONS_START",
  FETCH_EXECUTIONS_SUCCESS: "FETCH_EXECUTIONS_SUCCESS",

  EXPORT_CYCLE_START: "EXPORT_CYCLE_START",
  EXPORT_CYCLE_END: "EXPORT_CYCLE_END",

  UPLOAD_CYCLE_START: "UPLOAD_CYCLE_START",
  UPLOAD_CYCLE_END: "UPLOAD_CYCLE_END",
};